import React, { useContext } from 'react'
import { DefectContext } from './SingleDefect'
import TextField from '@mui/material/TextField'

const Summary = () => {
  const { setChangesPresent, defect, setDefect } = useContext(DefectContext)

  return (
    <TextField
      value={defect.summary ?? ''}
      onChange={(e) => {
        setDefect((prev) => ({
          ...prev,
          summary: e.target.value,
        }))
        setChangesPresent(true)
      }}
      label="Summary"
      size="small"
      helperText={`${(defect.summary ?? '').length}/50 characters`}
      inputProps={{ maxLength: 50 }}
    />
  )
}

export default Summary
